import { render, staticRenderFns } from "./TrainingsDashboard.vue?vue&type=template&id=cc879938&scoped=true&"
import script from "./TrainingsDashboard.vue?vue&type=script&lang=js&"
export * from "./TrainingsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsDashboard.vue?vue&type=style&index=0&id=cc879938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc879938",
  null
  
)

export default component.exports